export default __webpack_public_path__ + "static/media/GEAR.da9ba1ce.png";